// extracted by mini-css-extract-plugin
export default {"gridItem":"ParcelPage_gridItem__aN4YO"};